import actionCreatorFactory from "typescript-fsa";
import { CommonAsyncType } from "../../core/types";
import { ChangePasswordRequestBody, ChangePasswordResponse } from "../../core/api/requests/account/change-password/types";

const actionCreator = actionCreatorFactory("@@Account");

export const accountActions = {
    changePassword: actionCreator.async<CommonAsyncType<ChangePasswordResponse> & ChangePasswordRequestBody, ChangePasswordResponse>("CHANGE_PASSWORD"),
    resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
}; 